var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagstarInDemand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 16,
    viewBox: "0 0 73 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Tagstar",
    transform: "translate(-112 -743)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "prefix__In_Demand",
    fill: "#ff3f24",
    "data-name": "In Demand",
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: "11px",
    fontWeight: 700,
    transform: "translate(124 743)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "In Demand")), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon-Tagstar-In-Demand",
    transform: "translate(108.973 743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    fill: "#ff3f24",
    d: "M8.029 0l.112.839A9.474 9.474 0 0 0 9.98 4.644a4.94 4.94 0 0 1 .857 4.409 3.964 3.964 0 0 1-2.29 2.677l-.447.12a4.768 4.768 0 0 1-2.108.06l-.116-.025a3.23 3.23 0 0 1-1.411-.624 4.016 4.016 0 0 1-1.414-2.772A7.1 7.1 0 0 1 4.5 3.546l.594-.764.076 1a2.678 2.678 0 0 0 .192.759A10.787 10.787 0 0 1 7.48.614zm-.406 1.583a9.366 9.366 0 0 0-1.6 3.146L5.533 6.7l-.8-1.838a2.425 2.425 0 0 1-.107-.275 6.148 6.148 0 0 0-.893 3.8 3.26 3.26 0 0 0 1.165 2.252 2.649 2.649 0 0 0 1.13.5h.112a3.96 3.96 0 0 0 .8.08 4.256 4.256 0 0 0 1.027-.13l.447-.12a3.276 3.276 0 0 0 1.786-2.18 4.166 4.166 0 0 0-.737-3.71 11.607 11.607 0 0 1-1.84-3.496z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagstarInDemand);
export default __webpack_public_path__ + "static/media/tagstar-in-demand.2712cdf9.svg";
export { ForwardRef as ReactComponent };